import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function SiteFooter() {
  return <footer className="w-full bg-petrol py-14 text-white" data-id="element-275" data-mp="3r7zoxpdlwucu">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-276" data-mp="3mhj95ymbcwnb">
        <div className="grid gap-8 md:grid-cols-[minmax(0,1.4fr)_minmax(0,1fr)]" data-id="element-277" data-mp="3mg83tud7zgu3">
          <div data-id="element-278" data-mp="3hher445rbtuz">
            <p className="font-display text-lg font-extrabold" data-id="element-279" data-mp="3hhoerl3bxoxi">
              <span aria-hidden="true" data-id="element-280" data-mp="3dhe25pl1809o">🇦🇷</span> MegaPack Cocina Para Diabéticos™
            </p>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-white/75" data-id="element-281" data-mp="38h8fkntmd3yg">
              El sistema de cocina adaptada N°1 para personas con diabetes y sus familias en Argentina.
              Porque tener diabetes no debería significar renunciar al asado, al mate y a la cocina que
              te define.
            </p>
          </div>
          <ul className="space-y-3 text-sm text-white/80" data-id="element-282" data-mp="11qs9wqipfc08">
            <li data-id="element-283" data-mp="wrz4lldkmrb5">
              <a href="mailto:soportenovarcursos@gmail.com" className="flex items-center gap-2.5 transition-colors duration-150 ease-out hover:text-cta" data-id="element-284" data-mp="wta59cbpziy1">
                <MailIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-285" data-mp="1aqq096su9f1u" />
                soportenovarcursos@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-2.5" data-id="element-286" data-mp="10rsgeh6cy9p6">
              <InstagramIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-287" data-mp="10sai3tbshg4h" />
              @novarecursos
            </li>
            <li className="flex items-center gap-2.5" data-id="element-288" data-mp="1ojfvm1u9bwbm">
              <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-289" data-mp="1tfei1jw0z49e" />
              novarecursos.online
            </li>
          </ul>
        </div>

        <div className="mt-10 border-t border-white/15 pt-6 text-xs leading-relaxed text-white/60" data-id="element-290" data-mp="1epp9v4pilzzm">
          <p data-id="element-291" data-mp="27g7eia5w09f5">
            © MegaPack Cocina Para Diabéticos™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p className="mt-2" data-id="element-292" data-mp="2c8s7j9gyyihm">
            Este material es de carácter educativo y no reemplaza el diagnóstico, el tratamiento ni el
            seguimiento de un profesional de la salud.
          </p>
        </div>
      </div>
    </footer>;
}